import apiFarms from "../config/api_farms";
//import axios from "axios";
import getHeaders from "./getHeaders";

// const apiFarms = axios.create({
//   baseURL: "http://localhost:8082",
// });

export function index(payload) {
  const { groupId, farmId, page = 0, size = 20, sort, signal } = payload;
  const params = new URLSearchParams({ page, size });
  if (sort) params.append("sort", sort);

  return apiFarms.get(
    `/bovexo/${groupId}/farms/${farmId}/wagons?${params.toString()}`,
    getHeaders(false, signal)
  );
}

export function findById(payload) {
  const { groupId, farmId, id, signal } = payload;

  return apiFarms.get(
    `/bovexo/${groupId}/farms/${farmId}/wagons/${id}`,
    getHeaders(false, signal)
  );
}

export function save(payload) {
  const { groupId, farmId, body } = payload;

  return apiFarms.post(
    `/bovexo/${groupId}/farms/${farmId}/wagons`,
    body,
    getHeaders(false, null)
  );
}

export function update(payload) {
  const { groupId, farmId, id, body } = payload;

  return apiFarms.put(
    `/bovexo/${groupId}/farms/${farmId}/wagons/${id}`,
    body,
    getHeaders(false, null)
  );
}

export function activate(payload) {
  const { groupId, farmId, id } = payload;

  return apiFarms.patch(
    `/bovexo/${groupId}/farms/${farmId}/wagons/${id}/activate`,
    null,
    getHeaders(false, null)
  );
}

export function inactivate(payload) {
  const { groupId, farmId, id } = payload;

  return apiFarms.patch(
    `/bovexo/${groupId}/farms/${farmId}/wagons/${id}/inactivate`,
    null,
    getHeaders(false, null)
  );
}
